import React, { useState } from "react";
import { DateTimePicker } from "@material-ui/pickers";
import format from "date-fns/format";
import { Controller } from "react-hook-form";
import moment from "moment";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputAdornment from "@material-ui/core/InputAdornment";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
export default function DateTimePickerComponent({
  onChange,
  control,
  methods,
  ...props
}) {
  const maxPastDateDays = 60;
  const maxFutureDateDays = 7;
  const [selectedDate, setSelectedDateChange] = useState(
    moment(props.defaultValue, "DD-MM-YYYY HH:mm:ss").format(
      "YYYY-MM-DDTHH:mm:ss"
    )
  );
  return (
    <Controller
      as={
        <DateTimePicker
          // selected={selectedDate}
          label={props.Label}
          views={["year", "month", "date", "hours", "minutes"]}
          // minDate={
          //   props.minDate
          //      ? props.minDate
          //      : moment(new Date()).subtract(maxPastDateDays, "days")
          // }
          maxDate={
            props.maxDate
              ? props.maxDate
              : moment(new Date()).add(maxFutureDateDays, "days")
          }
          // disablePast
          ampm={false}
          fullWidth
          autoOk
          clearable
          required={props.required}
          disabled={props.disabled}
          margin="normal"
          size="small"
          // onError={//console.log}
          openTo="date"
          format="dd-MM-yyyy H:mm"
        />
      }
      onChange={([date]) => {
        try {
          setSelectedDateChange(date);
          console.log("date", date)
          props.getValueChanged(date);
        } catch {
          //console.log("getvalueChanged is not defined");
        }

        return date;
      }}
      name={props.name}
      rules={props.rules}
      error={props.error}
      control={control}
      defaultValue={
        props.defaultValue != null
          ? moment(props.defaultValue, "DD-MM-YYYY HH:mm:ss").format(
            "YYYY-MM-DDTHH:mm:ss.SSSS"
          )
          : null
      }
      inputVariant="outlined"
      size="small"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <DateRangeOutlinedIcon
              style={{ color: "grey", cursor: "pointer" }}
            />
          </InputAdornment>
        ),
      }}
    />
  );
}
